import React, {useEffect, useState} from 'react';
import {Dropdown} from "antd";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {light} from "@fortawesome/fontawesome-svg-core/import.macro";
import {isRTL} from "../../services/i18n";
import {Colors} from "../../styles/Colors";
import "./AntUI.scss"
import {IconSwitcher} from "../Icons8Generator/IconSwitcher";
import {GlobalConsts} from "../../styles/GlobalConsts";
import usePermissions from "../../services/Permissions";
import {useDispatch} from "react-redux";
import IconsGenerator from "../Icons8Generator/IconsGenerator";
import { openLimitedPackageModal } from '../../services/Helpers';
import {isMobile} from "../../services/Helpers";
import {HStack} from "native-base";
import AppText from "./AppText";

const CustomMenu = (props) => {
    const { items, anchor, triggerType, wrapperProps = {}, ...rest } = props;
    const [itemsNew, setItemsNew] = useState(items);
    const { has, hasLock } = usePermissions();
    const dispatch = useDispatch();

    useEffect(() => {
        const temp = items.reduce((acc, item) => {
            if((!item.permission || has(item.permission)) && (!item.hidePermission || !has(item.hidePermission)) && !item.override) {
                if(item.children && isMobile) {
                    return [...acc,
                        {
                            ...item,
                            label: getItemLabel(item),
                            key: !item.override && JSON.stringify(item),
                            icon: item.iconName ? <FontAwesomeIcon icon={IconSwitcher(GlobalConsts.iconPrefix.LIGHT, item.iconName)}/> : null,
                            children: item.children.map(c => {
                                c.icon = <FontAwesomeIcon icon={IconSwitcher(GlobalConsts.iconPrefix.LIGHT, c.iconName)}/>
                                return c
                            })
                        }]
                }
                else if(item.children && !isMobile) {
                    const childrenFiltered = item.children.filter(child => !child.permission || has(child.permission));
                    if (childrenFiltered.length === 1) {
                        return [...acc, {
                            ...childrenFiltered,
                            label: getItemLabel(childrenFiltered[0]),
                            key: !item.override && JSON.stringify(childrenFiltered[0]),
                            icon: childrenFiltered[0].iconName ? <FontAwesomeIcon icon={IconSwitcher(GlobalConsts.iconPrefix.LIGHT, childrenFiltered[0].iconName)}/> : null
                        }]
                    }
                    if (childrenFiltered.length === 0) {
                        return acc;
                    }
                    return [...acc,
                        {
                            ...item,
                            label: getItemLabel(item),
                            children: childrenFiltered.map(child => ({...child, label: child.title, key: !item.override && JSON.stringify(child),
                                icon: child.iconName ? <FontAwesomeIcon icon={IconSwitcher(GlobalConsts.iconPrefix.LIGHT, child.iconName)}/> : null
                            }))
                        }]
                }
                return [...acc,
                    {
                        ...item,
                        label: getItemLabel(item),
                        key: !item.override && JSON.stringify(item),
                        icon: item.iconName ? <FontAwesomeIcon icon={IconSwitcher(item.iconPrefix || GlobalConsts.iconPrefix.LIGHT , item.iconName)} style={{width: item.iconSize, height: item.iconSize}}/> : item.iconGeneratorName ? <IconsGenerator width={'16px'} height={'16px'} style={{marginInlineEnd: 0, marginLeft: 0}} name={item.iconGeneratorName}/> : null
                    }]
            }
            else if(item.override) {
                return [...acc,
                    {
                        ...item,
                        key: 'override',
                        label: (item.override)
                    }]
            }
            else return acc
        },[])
        setItemsNew(temp)
    }, [items]);

    const getItemLabel = (item) => {
        if(item.permission && hasLock(item.permission)) {
            return (
                <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center'}} id={`menu-${item.id}`}>
                    {item.name ?? item.title}
                    <FontAwesomeIcon icon={light('lock-keyhole')}/>
                </div>
            )
        } else if(item.children && item.iconName) {
            return (
                <HStack alignItems={'center'} space={'8px'}>
                    <FontAwesomeIcon icon={IconSwitcher(item.iconPrefix || GlobalConsts.iconPrefix.LIGHT , item.iconName)} />
                    <AppText>{item.name ?? item.title}</AppText>
                </HStack>
            )

        }
        else return <span id={`menu-${item.id}`}>{item.name ?? item.title}</span>
    }

    const handleItemClick = (item) => {
        if(!item.override) {
            if (!(item.permission && hasLock(item.permission))) {
                item.onPress(item);
            } else {
                openLimitedPackageModal(dispatch);
            }
        }
    }

    const onItemSelect = ({key}) => {
        if(key === "override") return;
        const itemObj = JSON.parse(key) // this returns a small object with no onpress function
        let item = null
        items.some(i => {
            if(i.id === itemObj.id) {
                item = i;
                return true;
            } else if (i.children) {
                const subItem = i.children.find(j => j.id === itemObj.id)
                if(subItem) {
                    item = subItem;
                    return true;
                }
            }
        })
        handleItemClick(item)
    }

    return (
        <div {...wrapperProps}>
            <Dropdown
                menu={{items: itemsNew, onClick: onItemSelect, expandIcon: <FontAwesomeIcon icon={isRTL() ? light('chevron-left') : light('chevron-right')} fontSize={'14px'} color={Colors.newDesign.mainText}/>}}
                trigger={[triggerType ?? 'click']}
                arrow
                {...rest}
            >
                {anchor}
            </Dropdown>
        </div>
    );
};

export default CustomMenu;